var isPasswordLengthValid = function isPasswordLengthValid(password) {
  return password.trim().length >= 8 && password.trim().length <= 72;
};
var passwordHasCapitalLetter = function passwordHasCapitalLetter(password) {
  return /(.*[A-Z].*)$/m.test(password.trim());
};
var passwordHasLowerCaseLetter = function passwordHasLowerCaseLetter(password) {
  return /(.*[a-z].*)$/m.test(password.trim());
};
var passwordHasNumbericValue = function passwordHasNumbericValue(password) {
  return /(.*\d.*)$/m.test(password.trim());
};
var passwordContainsPartialUserName = function passwordContainsPartialUserName(password, username) {
  if (password && username) {
    return passwordContainsPartialString(password.toLowerCase(), username.toLowerCase(), 4);
  }
  return false;
};
var passwordContainsInvalidCharacters = function passwordContainsInvalidCharacters(password) {
  return password.match(/[^a-zA-Z0-9"!#$%&'()*+,-.\/:;<=>\?@\[\]^_`{|}~]/) ? true : false;
};
var passwordHasSpecialCharacter = function passwordHasSpecialCharacter(password) {
  return /(.*["!#$%&'()*+,-.\/:;<=>\?@\[\]^_`{|}~].*)$/m.test(password.trim());
};

/**
 * @name passwordContainsString
 * @description Returns true when value matches substring of password
 */
var passwordContainsString = function passwordContainsString(password, value) {
  return passwordContainsPartialString(password, value, value.length);
};

/**
 * @name passwordContainsPartialString
 * @description Returns true when {take} number of characters match between strings
 */
var passwordContainsPartialString = function passwordContainsPartialString(password, value, take) {
  var parts = [];
  for (var i = 0; i < value.length - (take - 1); i += 1) {
    parts.push(value.substring(i, take + i));
  }
  return parts.some(function (s) {
    return password.trim().includes(s);
  });
};

export { isPasswordLengthValid, passwordContainsInvalidCharacters, passwordContainsPartialString, passwordContainsPartialUserName, passwordContainsString, passwordHasCapitalLetter, passwordHasLowerCaseLetter, passwordHasNumbericValue, passwordHasSpecialCharacter };
//# sourceMappingURL=index.es.js.map
